const getInitials = (name = '', letters = 3) =>
  name
    .split(' ')
    .slice(0, letters)
    .map(part => part[0])
    .join('')
    .toUpperCase();

export default getInitials;
